'use client';

import { type ComponentPropsWithoutRef } from 'react';
import { cn } from '@/lib/utils';

type SwatchIndicatorStatus = 'default' | 'unavailable';

export interface SwatchIndicatorProps extends ComponentPropsWithoutRef<'div'> {
    colour?: string;
    status?: SwatchIndicatorStatus;
}

export const SwatchIndicator = ({ className, colour, status = 'default', ...props }: SwatchIndicatorProps) => {
    return (
        <div className={cn('relative flex items-center justify-center', className)} {...props}>
            <span className="inline-block size-full rounded-full" style={{ backgroundColor: colour ?? '#ccc' }} />

            {status === 'unavailable' && (
                <span
                    aria-hidden
                    data-slot="swatch-unavailable-strike"
                    className={cn(
                        'pointer-events-none absolute rounded-full',
                        /* Outer ring = outline-offset + 1px stroke; clip slightly inside that outer edge so the slash does not read past the ring. */
                        'inset-[1px]'
                    )}>
                    <svg viewBox="0 0 100 100" className="size-full text-foreground/80">
                        <line
                            x1={0}
                            y1={0}
                            x2={100}
                            y2={100}
                            stroke="currentColor"
                            strokeLinecap="butt"
                            strokeWidth={5}
                        />
                    </svg>
                </span>
            )}
        </div>
    );
};
